import { render, staticRenderFns } from "./matriz-legal-2.vue?vue&type=template&id=4570b086&scoped=true&"
import script from "./matriz-legal-2.vue?vue&type=script&lang=js&"
export * from "./matriz-legal-2.vue?vue&type=script&lang=js&"
import style0 from "./matriz-legal-2.vue?vue&type=style&index=0&id=4570b086&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4570b086",
  null
  
)

export default component.exports